import './Estadisticas.css';

const stats = [
  { valor: '1,345+', label: 'Contenedores Transportados', sub: 'a Abril 2026' },
  { valor: '21,894+', label: 'Toneladas de Carga en Plataforma', sub: 'a Abril 2026' },
  { valor: '3', label: 'Terminales Habilitados', sub: 'Paracas · APM · DP World' },
];

export default function Estadisticas() {
  return (
    <section className="estadisticas">
      <div className="container">
        <p className="estadisticas__eyebrow">Nuestra experiencia nos respalda</p>
        <div className="estadisticas__grid">
          {stats.map((s, i) => (
            <div key={i} className="estadisticas__item">
              <span className="estadisticas__valor">{s.valor}</span>
              <span className="estadisticas__label">{s.label}</span>
              <span className="estadisticas__sub">{s.sub}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
